<template>
  <div
    class="list-item-content"
    :class="{'has-thumbnail': !!item.thumbnail, 'has-link': !!item.link, 'expanded': expand}"
    @mouseenter="mouseEnter"
    @mouseleave="mouseLeave"
    v-touch:swipe.left="swipeLeft"
    v-touch:swipe.right="swipeRight"
    @click="toggleExpand"
  >
    <span class="item-start">
      <a :href="item.link" @click.stop="" :class="{'item-link': !item.thumbnail}" v-if="item.link" target="_blank" rel="noopener">
        <img class="thumbnail" v-if="item.thumbnail" :src="item.thumbnail" alt="">
        <i class="fa fa-link link-icon-fallback" v-if="!item.thumbnail"></i>
      </a>
      <img class="thumbnail" v-if="item.thumbnail && !item.link" :src="item.thumbnail" alt="">
    </span>
    <div class="item-content">
      <div class="content-title">
        <a @click.stop="" :href="item.link" v-if="item.link" target="_blank">{{ item.content }}</a>
        <span v-else>
          {{ item.content }}
        </span>
        <span class="content-year" v-if="item.year">{{ item.year }}</span>
      </div>
      <div v-if="item.details" class="content-details">{{ item.details }}</div>
    </div>
    <item-menu
      v-if="menu"
      @edit="editItem"
      @delete="deleteItem"
      :editable="editable"
      :hover="hover"
      :item="item"
    ></item-menu>
  </div>
</template>

<script>
import ItemMenu from '@/components/ItemMenu'

export default {
  name: 'ListItemContent',
  props: {
    item: Object,
    editable: Boolean,
    menu: Boolean
  },
  data () {
    return {
      expand: false,
      hover: false,
    }
  },
  components: {
    ItemMenu,
  },
  methods: {
    toggleExpand () {
      let selection = window.getSelection()
      if (selection && selection.type !== "Range") {
        this.expand = !this.expand
      }
    },
    mouseEnter () {
      if (!this.$store.state.isTouch) {
        this.hover = true;
      }
    },
    mouseLeave () {
      if (!this.$store.state.isTouch) {
        this.hover = false;
      }
    },
    swipeLeft () {
      if (this.$store.state.isTouch) {
        this.hover = true;
      }
    },
    swipeRight () {
      if (this.$store.state.isTouch) {
        this.hover = false;
      }
    },
    editItem () {
      this.$emit('edit')
    },
    deleteItem () {
      this.$emit('delete')
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item-content {
  color: #e1e1ea;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0.5rem;
  cursor: pointer;

  .item-start{
    display: flex;
    flex: 0 0 45px;
    margin-right: 5px;
    .thumbnail {
      max-height: 50px;
      z-index: 2;
    }
    .item-link {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #343775;
      color: #5b60c5;
      border-radius: 50%;
      height: 35px;
      margin: -8px 0px;
      flex: 0 0 35px;
      &:hover {
        background: #4a4ea9;
        color: #7a80ff;
      }
      .link-icon-fallback {
        position: absolute;
        z-index: 1;
      }
    }
  }
  .item-content {
    width: 100%;
    min-width: 0;
    .content-title {
      text-align: left;
      display: flex;
      justify-content: space-between;
    }
    .content-year {
      opacity: 0.5;
      padding-left: 14px;
      font-size: 85%;
    }
    .content-details {
      text-align: initial;
      opacity: 0.5;
      font-size: 85%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &.expanded {
    .item-start {
      flex: 0 0 100px;
      margin-right: 15px;
      justify-content: center;
      .thumbnail {
        max-height: 150px;
      }
    }
    .item-content {
      align-self: flex-start;
      .content-title {
        min-height: 0px;
        text-align: center;
        display: flex;
        align-items: center;
        font-size: 1.2em;
        margin: 10px 0px 15px;
      }
      .content-details {
        white-space: normal;
        font-size: 100%;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  div.card div.card-body > ul.list-group > li.list-group-item > .list-item-content {
    &.has-thumbnail {
      padding: 0.5rem 0.5rem;
      .item-start {
        flex: 0 0 40px;
      }
    }
    .item-start {
      display: flex;
      flex: 0 0 30px;
    }
    .item-content {
      .content-title {
        padding-right: 40px;
      }
    }
  }
}
</style>
